import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewNovPhysis = () => import('./Index.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'nov_physis',
        name: 'NOV_PHYSIS',
        component: ViewNovPhysis,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
